module.exports = __webpack_public_path__ + "static/img/switch-3.d28c50f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/UC3880/switch-3.jpg
// module id = TWjR
// module chunks = 51